import React from "react";

import { MenuVertical, Rating, RatingFilled } from "icons";
import { useNavigate } from "react-router-dom";

import { Typography, Dropdown } from "clearsense-ui/components";

const Card = ({
  dashboard,
  setDashboardDetails,
  setShowModal,
  setShowAlert,
  updateFavorite,
}) => {
  const navigate = useNavigate();

  return (
    <div
      data-cy="dashboard-card"
      key={dashboard.id}
      className="bg-white dark:bg-gray-800 cursor-pointer shadow-md rounded-lg p-4 space-y-4 col-span-1 hover:shadow-xl"
      onClick={() =>
        navigate(`/consumption/reporting/dashboards/${dashboard.id}`)
      }
    >
      <div className="flex justify-between">
        <Typography
          style="h3"
          className="font-medium truncate"
          data-cy="dashboard-title-text"
        >
          {dashboard.title}
        </Typography>
        <div onClick={e => e.stopPropagation()}>
          <Dropdown
            data-cy="dashboard-dropdown-button"
            buttonProps={{
              icon: MenuVertical,
            }}
            buttonStyle="text"
            position="bottom-end"
            className="dark:text-gray-600"
          >
            <li
              onClick={() => {
                setDashboardDetails(dashboard);
                setShowModal(true);
              }}
              data-cy="edit-dashboard-button"
            >
              Edit
            </li>
            <li
              onClick={() => {
                setDashboardDetails(dashboard);
                setShowAlert(true);
              }}
              data-cy="delete-dashboard-button"
            >
              Delete
            </li>
          </Dropdown>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <Typography style="medium" className="text-gray-500">
          {dashboard.chart_count.length
            ? `Modified ${dashboard.updated_ago}`
            : `Created ${dashboard.created_ago}`}
          {" ago"}
        </Typography>
        {dashboard.favorite ? (
          <RatingFilled
            data-cy="dashboard-starred-icon"
            color="#5e5ce6"
            onClick={e => {
              e.stopPropagation();
              updateFavorite(dashboard.id, false);
            }}
          />
        ) : (
          <Rating
            data-cy="dashboard-star-icon"
            onClick={e => {
              e.stopPropagation();
              updateFavorite(dashboard.id, true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Card;
